import { useMutation } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';
import { isAxiosError } from '@/portainer/services/axios/utils/isAxiosError';

import { buildUrl } from './build-url';

export function useUpdatePortainerMutation() {
  return useMutation(updatePortainer, {
    ...withError('Unable to update Portainer'),
  });
}

async function updatePortainer() {
  try {
    await axios.post(buildUrl('update'));
  } catch (error) {
    if (!isAxiosError(error)) {
      throw error;
    }

    // if the server is disconnected, then everything went well
    if (!error.response || !error.response.status) {
      return;
    }

    throw parseAxiosError(error);
  }
}
